import _mock from "../_mock";

export const _schoolAds = [...Array(24)].map((_, index) => ({
  id: "id",
  title: "title",
  image: "ssssssssss",
  created_at: "2023-08-22T21:37:01.000000Z",
}));
